import { ButtonType, ButtonWidget, TabStyles } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/common/utilities/ImgUrl';
import { cssClass } from '~src/style';

export type AddNewDomainButtonProps = Readonly<{
    onAddNewDomainClicked: () => void;
}>;

export function AddNewDomainButton(props: AddNewDomainButtonProps) {
    return (
        <ButtonWidget
            buttonType={ButtonType.Outline}
            onClick={props.onAddNewDomainClicked}
            testId={'add-new-domain'}
            className={buttonClass}
            style={{ marginTop: TabStyles.Spacing.MediumSpace, marginBottom: TabStyles.Spacing.DefaultSpace }}
        >
            <img src={imgPath('plus_14px-small.svg')} alt={''} className={addDomainButtonClass} />
            <span>{Messages.bridgeSiteSettingsAddNewDomain()}</span>
        </ButtonWidget>
    );
}

const buttonClass = cssClass('add-new-domain-button', 'root', {
    display: 'block',
});

const addDomainButtonClass = cssClass('add-new-domain-button', 'plus-image', {
    verticalAlign: 'middle'
});
